export default [
  {
    path: '/client/opportunities/',
    meta: { auth: 'client' },
    props: true,
    component: () => import(/* webpackChunkName: "client-opportunities-list" */ "@/views/client/opportunities/List.vue")
  },
  {
    path: '/client/opportunities/:id',
    meta: { auth: 'client' },
    props: true,
    component: () => import(/* webpackChunkName: "client-opportunities-show" */ "@/views/client/opportunities/Show.vue")
  },
  {
    path: '/client/opportunities/:id/applications',
    meta: { auth: 'client' },
    props: true,
    component: () => import(/* webpackChunkName: "client-applications-tracker" */ "@/views/client/opportunities/ApplicationsTracker.vue")
  },
  {
    path: '/client/opportunities/:id/eligibilities',
    meta: { auth: 'client' },
    props: true,
    component: () => import(/* webpackChunkName: "client-eligibility-analytics" */ "@/views/client/opportunities/EligibilityAnalytics.vue")
  }
]
